(function (root) {
  'use strict';
  if (root.JEGroomsmanCart) return;
  root.JEGroomsmanCart = Object.freeze({ tokenProperty: '_Groomsman submission', payloadProperty: '_Groomsman payload',
    create(config = {}) {
      if (!root.JEBirthflowerCart?.create) throw new Error('The cart tools did not load. Refresh the page to try again.');
      return root.JEBirthflowerCart.create({ ...config, kind: 'groomsman' });
    }
  });
})(typeof globalThis !== 'undefined' ? globalThis : this);
